import { DARK_GRAY } from "@shape/reef-shared";
import styled from "styled-components";

export const Columns = styled.div`
  display: flex;
  & > div {
    &.text-field,
    &.text-area-field {
      flex-grow: 1;
    }
    &.files-field > div {
      position: relative;
      label + div {
        white-space: nowrap;
        position: absolute;
        right: 0;
        div {
          margin-right: 0;
          margin-left: 8px;
        }
      }
    }
    &.text-field,
    &.text-area-field,
    &.files-field {
      &:not(:first-child) {
        margin-left: 36px;
        align-self: flex-end;
      }
    }
  }
`;

export const MatrixButton = styled.div`
  margin-top: 24px;
  margin-left: 12px;

  svg {
    margin-left: 0;
    margin-right: 8px;
  }
`;

export const Section = styled.div`
  animation: fadeIn 0.2s ease;
  padding-top: 8px;
  margin-bottom: 55px;
  > h4 {
    margin-top: 0px;
  }
`;

export const Files = styled.div`
  label {
    font-weight: 700;
    text-transform: uppercase;
  }
`;

export const BoxColumn = styled.div`
  background-color: ${DARK_GRAY};
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;

  display: grid;
  grid-template-columns: 35% 65%;
`;
